import { Col, Container, Row } from "reactstrap";
import ProductGrid from "./ProductGrid";

const Food = () => {
  return (
    <div className='page-body'>
      <Container fluid>
      <Row>
        <Col sm="12">
          <ProductGrid />
        </Col>
      </Row>
    </Container>
    </div>
  )
}

export default Food